import { Table, Button } from "antd";
import React, { useEffect, useState } from "react";
import type { ColumnsType } from "antd/es/table";
import { API } from "../../config/API";
import { GET } from "../../utils/apirequest";
interface SubscriptionData {
  id: number;
  attributes: {
    edition_type: any;
    duration_months: any;
    start_date: any;
    end_date: any;
    web_user: {
      data: {
        id: number;
        attributes: {
          full_name: any;
          email: any;
        };
      };
    };
    transaction_id: {
      data: {
        id: number;
        attributes: {
          amount: any;
        };
      }[];
    };
  };
}

const SubscriptionList = () => {
  const [data, setData] = useState<SubscriptionData[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    let url = API.GET_SUBSCRIBTION;
    try {
      const response: any = await GET(url, null, null);
      if (response.data) {
        setData(response.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const downloadCSV = () => {
    const headers = [
      "Full Name",
      "Edition Type",
      "Duration (Months)",
      "Amount",
      "Start Date",
      "End Date",
    ];

    const rows = data?.map((record) => [
      record?.attributes?.web_user?.data?.attributes?.full_name || "",
      record?.attributes?.edition_type || "",
      record?.attributes.duration_months || "",
      record?.attributes?.transaction_id?.data?.[0]?.attributes?.amount || "",
      new Date(record?.attributes?.start_date).toLocaleDateString() || "",
      new Date(record?.attributes?.end_date).toLocaleDateString() || "",
    ]);

    const csvContent = [
      headers.join(","),
      ...rows.map((row) => row?.map((cell) => `"${cell}"`).join(",")),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "subscriptions.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const columns: ColumnsType<SubscriptionData> = [
    {
      title: "Full Name",
      key: "fullName",
      render: (record: SubscriptionData) => {
        return record?.attributes?.web_user?.data?.attributes?.full_name;
      },
    },
    {
      title: "E-mail",
      key: "email",
      render: (record: SubscriptionData) => {
        return record?.attributes?.web_user?.data?.attributes?.email;
      },
    },
    {
      title: "Edition Type",
      dataIndex: ["attributes", "edition_type"],
      key: "editionType",
    },
    {
      title: "Duration (Months)",
      dataIndex: ["attributes", "duration_months"],
      key: "duration",
    },
    {
      title: "Amount",
      key: "amount",
      render: (record: SubscriptionData) => {
        return record?.attributes?.transaction_id?.data?.[0]?.attributes
          ?.amount;
      },
    },
    {
      title: "Start Date",
      dataIndex: ["attributes", "start_date"],
      key: "startDate",
      render: (text: string) => new Date(text).toLocaleDateString(),
    },
    {
      title: "End Date",
      dataIndex: ["attributes", "end_date"],
      key: "endDate",
      render: (text: string) => new Date(text).toLocaleDateString(),
    },
  ];

  return (
    <div className="subscription-list-container">
      <div className="d-flex justify-content-end">
        <Button

          type="primary"
          onClick={downloadCSV}
          style={{ marginBottom: 16,backgroundColor:"#b72c6f" }}
        >
          Download
        </Button>
      </div>
      <Table
        columns={columns}
        dataSource={data}
        bordered
        loading={loading}
        pagination={{
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
        }}
        rowKey="id"
        className="subscription-table"
      />
    </div>
  );
};

export default SubscriptionList;
